import { render, staticRenderFns } from "./Statement.vue?vue&type=template&id=0c385ae4&"
import script from "./Statement.vue?vue&type=script&lang=js&"
export * from "./Statement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports